<template>
    <el-dialog
        title="工具策略批量操作"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        @close="closeDialog"
        width="40%">
        <el-form :model="form" :rules="dynamicRules" ref="form" label-width="210px" class="demo-ruleForm">
            <el-form-item v-for="(item, index) in defaultSetProperty" :key="index" :label="item.text" :prop="item.key">
                <el-input v-model="form[item.key]" placeholder=""></el-input>
                <span>{{ item.unit }}</span>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" size="medium" @click="save">保存</el-button>
            <el-button size="medium" @click="closeDialog">取 消</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props:{
        defaultSetProperty: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: { }
        };
    },
    computed: {
        dynamicRules() {
            const rules = {};
            this.defaultSetProperty.forEach(item => {
                rules[item.key] = [ 
                    { required: true, message: '请输入' + item.text.split('：')[0], trigger: 'blur' }
                ];
            });
            return rules;
        }
    },
    methods: {
        // 保存
        save() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.$store.dispatch('manage/public', {
                        query: this.form,
                        requestInterfaceName: 'batchAddToolProperty'
                    }).then(res=>{
                        if(res.code == 0) {
                            this.$message.success('保存成功');
                            this.$emit('batchAddSuccess');
                            this.closeDialog();
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                }
            });
        },
        // 取消
        closeDialog() {
            this.dialogVisible = false;
            this.$refs['form'].resetFields();
        }
    }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
    .el-dialog__body {
        .el-form {
            .el-form-item__content {
                display: flex;
                align-items: center;
                .el-input {
                    width: 200px;
                    margin-right: 10px;
                }
            }
        }
    }
}
</style>